export class SqlInfo {
  constructor(
    private _companyCode?: string,
    private _glCode?: string,
    private _group?: string,
    private _id?: number,
  ) {}

  set ID(id: number) {
    this._id = id;
  }
  get ID(): number {
    return this._id;
  }

  set CompanyCode(value: string) {
    this._companyCode = value;
  }
  get CompanyCode(): string {
    return this._companyCode;
  }
  set GLCode(value: string) {
    this._glCode = value;
  }
  get GLCode(): string {
    return this._glCode;
  }

  set Group(value: string) {
    this._group = value;
  }
  get Group(): string {
    return this._group;
  }
}

export class Company {
  constructor(
    _id?: number,
    _name?: string,
    _address?: string,
    _companyCode?: string,
    _contactNo?: string,
    _branchId?: number,
    _regNo?: string,
    _group?: number,
    _dateOperating?: Date,
    _unverifedCustomerCount?: number,
    _requireConsentForm?: boolean,
    _uid?: string,
  );
  constructor(
    private _id: number,
    private _name: string,
    private _address: string,
    private _companyCode: string,
    private _contactNo: string,
    private _branchId: number,
    private _regNo?: string,
    private _group?: number,
    private _dateOperating?: Date,
    private _unverifedCustomerCount?: number,
    private _requireConsentForm?: boolean,
    private _uid?: string,
  ) {}

  set ID(id: number) {
    this._id = id;
  }
  get ID(): number {
    return this._id;
  }

  set Name(name: string) {
    this._name = name;
  }
  get Name(): string {
    return this._name;
  }

  set CompanyCode(companyCode: string) {
    this._companyCode = companyCode;
  }
  get CompanyCode(): string {
    return this._companyCode;
  }

  set Address(address: string) {
    this._address = address;
  }
  get Address(): string {
    return this._address;
  }

  set ContactNo(contactNo: string) {
    this._contactNo = contactNo;
  }
  get ContactNo(): string {
    return this._contactNo;
  }

  set BranchId(value: number) {
    this._branchId = value;
  }
  get BranchId(): number {
    return this._branchId;
  }

  set RegNum(regNo: string) {
    this._regNo = regNo;
  }
  get RegNum(): string {
    return this._regNo;
  }

  set Group(group: number) {
    this._group = group;
  }
  get Group(): number {
    return this._group;
  }

  set DateOperating(dateOperating: Date) {
    this._dateOperating = dateOperating;
  }
  get DateOperating(): Date {
    return this._dateOperating;
  }

  set UnverifiedCutsomerCount(unverifedCustomerCount: number) {
    this._unverifedCustomerCount = unverifedCustomerCount;
  }
  get UnverifiedCutsomerCount(): number {
    return this._unverifedCustomerCount;
  }

  get RequireConsentForm(): boolean {
    return this._requireConsentForm;
  }
  set RequireConsentForm(value: boolean) {
    this._requireConsentForm = value;
  }

  get UID(): string {
    return this._uid;
  }
  set UID(value: string) {
    this._uid = value;
  }
}

export interface ICompanyGroup {
  id: number;
  name: string;
}

export interface ICashBook {
  initialCashBookBalance: number;
  initialCashBookDate: Date;
}

export interface IAPICashBook {
  initialCashBookBalance: number;
  initialCashBookDate: string;
}

export interface IAPICompany {
  name: string;
  address: string;
  companyCode: string;
  group: number;
  contactNo: string;
  businessBranchId: number;
  regNo: string;
  dateOperating: string;

  // GET
  id?: number,
  requireConsentForm?: boolean
  unverifedCustomerCount?: number,
  uid?: string
}

export interface IAPISqlInfo {
  glCode: string;
}
